export const EDIT_BUSINESS_PROFILE_MODAL = "EDIT_BUSINESS_PROFILE_MODAL";
export const SUBSCRIPTION_DETAILS = "SUBSCRIPTION_DETAILS";
export const BUSINESS_STATUS_PENDING = "pending";
export const BUSINESS_STATUS_VERIFIED = "verified";
export const BUSINESS_STATUS_NOT_VERIFIED = "not_verified";
